// extracted by mini-css-extract-plugin
module.exports = {"linkButton":"_3Zxe3X"};